let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdNVP")).then(() => parcelRequire('4Ktr0'));